export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto py-12 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="lg:col-span-1">
              <a href="#hero" className="flex items-center gap-2 mb-4 cursor-pointer no-underline">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-trophy-line text-background-50 text-lg"></i>
                </div>
                <span className="font-heading font-bold text-lg text-background-50 whitespace-nowrap">
                  每日大赛mrds
                </span>
              </a>
              <p className="text-foreground-400 text-sm leading-relaxed">
                全民创作竞技平台，每日更新话题赛道。通过大赛发布页面提交作品，发送爆料提名上榜，让每一个好内容都被看见。
              </p>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-100 text-sm mb-4">
                快速导航
              </h4>
              <ul className="space-y-2.5">
                <li><a href="#faq" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer no-underline">常见问题</a></li>
                <li><a href="#features" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer no-underline">平台优势</a></li>
                <li><a href="#ranking" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer no-underline">热度榜单</a></li>
                <li><a href="#updates" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer no-underline">最新快讯</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-100 text-sm mb-4">
                热门赛道
              </h4>
              <ul className="space-y-2.5">
                <li><a href="#carousel" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer no-underline">摄影大赛</a></li>
                <li><a href="#carousel" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer no-underline">美食日记</a></li>
                <li><a href="#carousel" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer no-underline">街拍纪实</a></li>
                <li><a href="#carousel" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer no-underline">文字创作</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-100 text-sm mb-4">
                合作伙伴
              </h4>
              <p className="text-foreground-400 text-sm leading-relaxed">
                我们正在寻找更多志同道合的伙伴一起打造创作生态，敬请期待。
              </p>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-foreground-700/30">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-foreground-500 text-xs">
                &copy; 2026 每日大赛mrds. 保留所有权利。
              </p>
              <p className="text-foreground-500 text-xs">
                全民创作竞技平台 · 每日更新 · 透明榜单
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}